import s from "./InputNumberRange.module.scss";
import { InputNumber } from "@/components/UI/form/InputNumber";
import { SpriteIcon } from "@/components/UI/SpriteIcon";
import ArrowRightIcon from "public/img/icons/arrow-right-long.svg";
import { useEffect, useRef, useState } from "react";
type InputNumberRangeProps = {
  name: string;
  min: number;
  max: number;
  initialValue?: {
    from?: string;
    to?: string;
  };
  onChange?: (from?: number, max?: number) => void;
};

export const InputNumberRange = ({ name, min, max, onChange, initialValue }: InputNumberRangeProps) => {
  const [currentMin, setCurrentMin] = useState(min);
  const [currentMax, setCurrentMax] = useState(max);
  const [fromValue, setFromValue] = useState(Number(initialValue?.from) || undefined);
  const [toValue, setToValue] = useState(Number(initialValue?.to) || undefined);
  const [prevName, setPrevName] = useState(name);

  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleFromFieldChange = (value?: number) => {
    setCurrentMin(value ? (value >= min ? value : min) : min);
    setFromValue(value);
    onChange?.(value, toValue);
  };

  const handleToFieldChange = (value?: number) => {
    setCurrentMax(value ? (value <= max && value >= currentMin ? value : max) : max);
    setToValue(value);
    onChange?.(fromValue, value);
  };

  useEffect(() => {
    setCurrentMin(min);
    setCurrentMax(max);
  }, [min, max]);

  useEffect(() => {
    if (name === prevName) return;
    if (!wrapperRef.current) return;
    const [fromInput, toInput] = Array.from(wrapperRef.current.querySelectorAll("input"));
    if (!fromInput || !toInput) return;
    fromInput.value = "";
    toInput.value = "";
    setPrevName(name);
  }, [name, prevName]);

  return (
    <div className={s.wrapper} ref={wrapperRef}>
      <InputNumber
        placeholder="From"
        name={`${name}From`}
        min={min}
        max={currentMax}
        onChange={handleFromFieldChange}
        initialValue={initialValue?.from}
        showControls={false}
        noStyle
        className={s.input}
      />
      <SpriteIcon icon={ArrowRightIcon} className={s.icon} />
      <InputNumber
        placeholder="To"
        name={`${name}To`}
        min={currentMin}
        max={max}
        onChange={handleToFieldChange}
        initialValue={initialValue?.to}
        showControls={false}
        noStyle
        className={s.input}
      />
    </div>
  );
};
